export default __webpack_public_path__ + "static/media/lib-7.2a613dbe.webp";